import { useState } from "react";
import { PessoaDto } from "src/pages/Privada/Entidade/Pessoa/Pessoa.Dto";
import { PessoaFiltrar } from "src/services/Entidade.Service";

export const ConsultarPessoa = () => {
  const [loading, setLoading] = useState(false);
  const PessoaBuscar = (query: string): Promise<PessoaDto[]> => {
    setLoading(true);
    return new Promise<PessoaDto[]>((resolve, reject) => {
      PessoaFiltrar({ nome: query })
        .then((response) => {
          if (response.data.success) {
            const data = response.data.data;
            resolve(data);
          } else {
            if (response.status === 204) {
              resolve([]);
            } else {
              response.data.notifications.forEach((err: any) =>
                console.log(err.message)
              );
              reject("Erro ao buscar dados");
            }
          }
        })
        .catch((error) => {
          console.log(error);
          reject("Erro ao buscar dados");
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  return {
    PessoaBuscar,
    loading,
  };
};
